import { Clause, LegalPage, SUPPORT_EMAIL } from "@/components/store/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      testId="terms-page"
      eyebrow="Terms & conditions"
      title="Terms of sale and use"
      intro="These terms apply to everything you buy or read on this site. By placing an order you accept them. Last updated June 2026."
    >
      <Clause heading="1. Who you are buying from">
        <p>This is the poet's own shop. Books are sold directly by ShansoBooks, with no reseller in between. Our contact address for all matters is <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-primary hover:underline">{SUPPORT_EMAIL}</a>.</p>
      </Clause>

      <Clause heading="2. Prices and payment">
        <p>All prices are in Indian Rupees and include GST where applicable. Printed books are currently taxed at 0%; any tax is shown on your invoice.</p>
        <p>Payment is collected through Cashfree Payments. We never see or store your card, UPI or bank credentials. An order is confirmed only after the payment gateway reports success; until then it stays in a pending state and no stock is reserved.</p>
      </Clause>

      <Clause heading="3. Orders, stock and pricing errors">
        <p>Available copies are shown live on the site and reduce with each paid order. If a title sells out between your adding it to the bag and paying, or if an obvious pricing error occurs, we may cancel the order and return the amount paid for that specific order; we will always tell you first by email.</p>
      </Clause>

      <Clause heading="4. Shipping and delivery">
        <p>Orders are packed by hand and dispatched within 2–3 working days, by India Post or a private courier, anywhere in India. You will receive the courier name, tracking number and a tracking link by email.</p>
        <p>Delivery timelines are estimates given by the courier and are not guaranteed. Risk passes to you once the parcel is handed to the courier. Please give a complete address with a working phone number and PIN code; parcels returned to us because of a wrong or incomplete address, or because delivery was repeatedly refused, can be re-shipped only after fresh shipping charges are paid.</p>
      </Clause>

      <Clause heading="5. No returns, cancellations or refunds">
        <p>All sales are final. Once payment is made, orders cannot be cancelled, returned, exchanged or refunded. Please see the <a href="/refund-policy" className="font-semibold text-primary hover:underline">refund policy</a> for the full position.</p>
      </Clause>

      <Clause heading="6. Personalised copies and signed bookplates">
        <p>Where you ask for a signed dedication, it is written by hand exactly as you typed it. Personalised copies cannot be altered, cancelled or refunded once written, so please check your spelling before paying.</p>
      </Clause>

      <Clause heading="7. Copyright in the poems">
        <p>All poems, illustrations, translations, book covers and site text are the intellectual property of Shunmugavel and are protected by copyright. Every poem page carries the notice “© 2026 Shunmugavel · Agamali Kaeleer · ShansoBooks — All rights reserved”.</p>
        <p>You may share the poem pages from this site privately, or on social media, only in the form provided, with the copyright notice intact and with credit to the poet. You may not crop out the notice, alter the artwork or text, reprint, publish, sell, perform commercially, train machine-learning models on, or otherwise reproduce any part of the work without written permission.</p>
      </Clause>

      <Clause heading="8. Ebooks, if and when offered">
        <p>Any ebook sold here is a personal, non-transferable licence for your own reading. Each file is watermarked with the buyer's name and email. Sharing, uploading or reselling the file is a breach of these terms and of copyright.</p>
      </Clause>

      <Clause heading="9. Your account">
        <p>Keep your password to yourself; you are responsible for activity on your account. We store only what is needed to fulfil orders and issue invoices — your name, email, phone, shipping address and order history — and we never sell your data. Reviews you submit may be published with your first name and city after we read them.</p>
      </Clause>

      <Clause heading="10. Reviews and submissions">
        <p>By submitting a review you allow us to publish, shorten for length, or decline to publish it, and to reply to it publicly. Please keep it about the book.</p>
      </Clause>

      <Clause heading="11. Liability">
        <p>Our responsibility for any order is limited to the amount you paid for that order. We are not liable for courier delays, force majeure events, or indirect losses.</p>
      </Clause>

      <Clause heading="12. Changes and governing law">
        <p>We may update these terms; the version on this page at the time of your order applies to it. These terms are governed by the laws of India, and the courts of Tamil Nadu have exclusive jurisdiction.</p>
      </Clause>
    </LegalPage>
  );
}
